import { IconTrash } from '@tabler/icons-react';
import React from 'react';

interface RoomHeaderPropsV4 {
    index: number;
    deleteRoom: (index: number) => void;
    isUpdateMode?: boolean;
}

const RoomHeaderV4: React.FC<RoomHeaderPropsV4> = ({ index, deleteRoom, isUpdateMode }) => (
    <div className="mt-6 border-bottom d-flex justify-content-between">
        <h3 className="fw-normal">Room {index + 1}</h3>
        {(index !== 0 || isUpdateMode) && (
            <button
                type='button'
                className="text-danger fw-normal p-0 border-0 bg-transparent d-flex align-items-center"
                onClick={() => deleteRoom(index)}
            >
                <IconTrash size={20} className="me-1" />
                Remove Room
            </button>
        )}
    </div>
);

export default RoomHeaderV4;